var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.21 24H21.21C21.76 24 22.21 23.55 22.21 23C22.21 22.45 21.76 22 21.21 22H10.21C9.65996 22 9.20996 22.45 9.20996 23C9.20996 23.55 9.65996 24 10.21 24ZM10.21 19H18.21C18.76 19 19.21 18.55 19.21 18C19.21 17.45 18.76 17 18.21 17H10.21C9.65996 17 9.20996 17.45 9.20996 18C9.20996 18.55 9.65996 19 10.21 19ZM9.20996 13C9.20996 13.55 9.65996 14 10.21 14H21.21C21.76 14 22.21 13.55 22.21 13C22.21 12.45 21.76 12 21.21 12H10.21C9.65996 12 9.20996 12.45 9.20996 13ZM26.51 20.88L23.63 18L26.51 15.12C26.9 14.73 26.9 14.1 26.51 13.71C26.12 13.32 25.49 13.32 25.1 13.71L21.51 17.3C21.12 17.69 21.12 18.32 21.51 18.71L25.1 22.3C25.49 22.69 26.12 22.69 26.51 22.3C26.89 21.91 26.9 21.27 26.51 20.88Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menu-close.2099ab69.svg";
export { ForwardRef as ReactComponent };